import React from 'react';
import classNames from 'classnames';
import { DESTINATION_TYPE, CUSTOM_DESTINATION_OPTIONS } from '../../stores/reducers/broadcasting';

interface Props {
	buttonCallback: Function;
	buttonClassNames?: string;
}

export default function StreamingDestinations(props: Props) {
	const {
		buttonCallback,
		buttonClassNames,
	} = props;

	return (
		<>
			{Object.entries(DESTINATION_TYPE)
				.filter(([, val]) => val > -1 && val !== DESTINATION_TYPE.ALLHANDS)
				.map((destinationType, index) => (
						<button
							key={index}
							onClick={() => buttonCallback(CUSTOM_DESTINATION_OPTIONS[destinationType[1]])}
							className={classNames(buttonClassNames)}
						>
							<img
								src={CUSTOM_DESTINATION_OPTIONS[destinationType[1]].description}
								alt={CUSTOM_DESTINATION_OPTIONS[destinationType[1]].label}
								className='image margin-right-medium'
							/>
							<span className='text text-transform-capitalize text-white'>
								{CUSTOM_DESTINATION_OPTIONS[destinationType[1]].label}
							</span>
						</button>
				))
			}
		</>
	);
}
